import ColorHash from 'color-hash';
import tinycolor2 from 'tinycolor2';
import { darken } from '@classify/react-core-components/styles';

import { palette } from '@classify/react-core-components/Theme';

const colorHash = new ColorHash();

export const COLOR_DEFAULT = '#4D4D4D';
const wcagAAAMinimumContrastRatio = 7.1;

const getUserColor = (userId, userName) => {
  if (!userId || !userName) {
    return COLOR_DEFAULT;
  }

  let backgroundColor = `rgb(${colorHash.rgb(userId + userName).toString()})`;
  const isReadable = tinycolor2.isReadable(backgroundColor, palette.text.onContrasted, {
    level: 'AAA',
    size: 'small',
  });

  while (
    tinycolor2.readability(backgroundColor, palette.text.onContrasted) <
      wcagAAAMinimumContrastRatio &&
    isReadable === false
  ) {
    backgroundColor = darken(backgroundColor, 0.1);
  }

  return backgroundColor;
};

export default getUserColor;
